import React from 'react';
import { TFunction, withTranslation } from 'react-i18next';
import { KibBreadcrumbs, KibBreadcrumbsItem } from '@chewy/kib-menus-react';
import { PetInterface } from '../../types/pet';
import '@chewy/kib-menus-styles/dist/styles/kib-breadcrumbs.css';
import { getPetProfilePath } from '../../util/config';
import './puppy-guide-breadcrumbs.scss';

const baseKey = 'puppyGuide.breadCrumbs';

export const BreadCrumbs = ({
  petProfile,
  t,
}: {
  petProfile?: PetInterface;
  t: TFunction<string>;
}) => (
  <KibBreadcrumbs className="puppy-guide-breadcrumbs">
    <KibBreadcrumbsItem href="/app/account">{t(`${baseKey}.firstLink`)}</KibBreadcrumbsItem>
    {petProfile ? (
      <KibBreadcrumbsItem
        data-testid="puppyguide-petprofile-link"
        href={getPetProfilePath(petProfile.id)}
      >
        {petProfile.name}
      </KibBreadcrumbsItem>
    ) : null}
    <KibBreadcrumbsItem current>{t(`${baseKey}.thirdLink`)}</KibBreadcrumbsItem>
  </KibBreadcrumbs>
);

export default withTranslation()(BreadCrumbs);
